"use strict";
var _MavenGraphBuilder_graph;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MavenGraphBuilder = void 0;
const tslib_1 = require("tslib");
class MavenGraphBuilder {
    constructor(rootId) {
        _MavenGraphBuilder_graph.set(this, void 0);
        tslib_1.__classPrivateFieldSet(this, _MavenGraphBuilder_graph, {
            rootId,
            nodes: {
                [rootId]: { dependsOn: [] },
            },
        }, "f");
    }
    add(id) {
        if (!this.node(id)) {
            tslib_1.__classPrivateFieldGet(this, _MavenGraphBuilder_graph, "f").nodes[id] = { dependsOn: [] };
        }
    }
    node(id) {
        return tslib_1.__classPrivateFieldGet(this, _MavenGraphBuilder_graph, "f").nodes[id];
    }
    connect(parentId, id) {
        this.add(parentId);
        this.add(id);
        const node = this.node(parentId);
        if (!node)
            return;
        if (!node.dependsOn.includes(id)) {
            node.dependsOn.push(id);
        }
    }
    get graph() {
        return tslib_1.__classPrivateFieldGet(this, _MavenGraphBuilder_graph, "f");
    }
}
exports.MavenGraphBuilder = MavenGraphBuilder;
_MavenGraphBuilder_graph = new WeakMap();
//# sourceMappingURL=maven-graph-builder.js.map